(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carousels = document.querySelectorAll('.product-carousel');
    
    carousels.forEach(carousel => {
      const images = carousel.querySelectorAll('.carousel-image');
      const dots = carousel.querySelectorAll('.carousel-dot');
      const prevBtn = carousel.querySelector('.carousel-prev');
      const nextBtn = carousel.querySelector('.carousel-next');
      
      if (images.length <= 1) return;
      
      let currentIndex = 0;
      
      function showImage(index) {
        // Remove active class from all images and dots
        images.forEach(img => img.classList.remove('active'));
        dots.forEach(dot => dot.classList.remove('active'));
        
        // Add active class to current image and dot
        images[index].classList.add('active');
        if (dots[index]) {
          dots[index].classList.add('active');
        }
        
        currentIndex = index;
      }
      
      function nextImage(e) {
        e.preventDefault();
        e.stopPropagation();
        const newIndex = (currentIndex + 1) % images.length;
        showImage(newIndex);
      }
      
      function prevImage(e) {
        e.preventDefault();
        e.stopPropagation();
        const newIndex = (currentIndex - 1 + images.length) % images.length;
        showImage(newIndex);
      }
      
      // Event listeners for buttons
      if (nextBtn) {
        nextBtn.addEventListener('click', nextImage);
      }
      
      if (prevBtn) {
        prevBtn.addEventListener('click', prevImage);
      }
      
      // Event listeners for dots
      dots.forEach((dot, index) => {
        dot.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          showImage(index);
        });
      });
      
      // Survol de la card : bascule sur la 2e photo, retour à la 1re à la sortie
      const productItem = carousel.closest('.product-item');
      if (productItem) {
        productItem.addEventListener('mouseenter', () => showImage(1));
        productItem.addEventListener('mouseleave', () => showImage(0));
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
